export default function Resultreducer(resultstate,action) {
 console.log("lll",resultstate,action)
 const type=action.type//متغير داخله النوع والهمسه ايش هي ناقص او زايد او غيره
  if(type=="sum"){
    // const result=(Number(firstnumberinput)+Number(Secoundnumberinput))
    // return result;   
    const {Firstnamber,Secoundnumber}=action.dypaid;
    return Number(Firstnamber)+Number(Secoundnumber);
  }else if(type=="sup"){
    // const result=(Number(firstnumberinput)-Number(Secoundnumberinput))
    // return result;
    // return result;   
    const {Firstnamber,Secoundnumber}=action.dypaid;
    return Number(Firstnamber)-Number(Secoundnumber);
  }else if(type=="mult"){
    // const result=(Number(firstnumberinput)*Number(Secoundnumberinput))
    // return result;  
    // return result;   
    const {Firstnamber,Secoundnumber}=action.dypaid;
    return Number(Firstnamber)*Number(Secoundnumber);
  }else if(type=="duv"){
    // const result=(Number(firstnumberinput)*Number(Secoundnumberinput))
    // return result;  
    // return result;   
    const {Firstnamber,Secoundnumber}=action.dypaid;
    return Number(Firstnamber)/Number(Secoundnumber);
  }
}